module.exports = __webpack_public_path__ + "img/nt86-01-82-1.prt.ff0f9f9a.jpg";